export const SCRIPT_SRC = 'https://eu-library.klarnaservices.com/lib.js';
export const CLIENT_ID = '5c0974fa-c231-5997-8978-4b3593bb9ccc';
export const COOKIES = ['ku1-vid', 'ku1-sid'];
